import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_18bad330";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_18bad330" };
/** script content **/
require("./scroll-nav-bar.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex18bad330%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fscroll-nav-bar%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_18bad330"],
    ctorType: "component",
    outputPath: "components/index18bad330/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'nav-item-contentdefault': getComponent(require("./nav-item-content.mpx?isComponent&outputPath=components%2Fnav-item-content54eaf879%2Findex")), 'mpx-scroll-view': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), { __mpxBuiltIn: true }), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: { "nav-item-content": { "default": "./nav-item-content" } },
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
